import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { toast } from "./ui/sonner";
import { UserCog, LogOut, Loader2 } from "lucide-react";

/* 代操作横幅：正在以分包商身份操作 → 一键返回自己的账号 */
export const ImpersonationBanner = () => {
  const { user, lang, stopImpersonation } = useApp();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const zh = lang === "zh";
  if (!user?.impersonatedBy) return null;
  const isSub = user.role === "subcontractor";
  const exit = async () => {
    setBusy(true);
    try {
      const ok = await stopImpersonation();
      if (ok && typeof ok === "object") toast.success(zh ? `已返回自己的账号 · 代操作 ${ok.minutes ?? 0} 分钟 · ${ok.changes} 项变更，小结已发到铃铛` : `Back · ${ok.minutes ?? 0} min · ${ok.changes} changes (recap in bell)`, { duration: 6000 });
      else toast.success(ok ? (zh ? "已返回自己的账号" : "Back to your account") : (zh ? "会话已结束，请重新登录" : "Session ended"));
      nav(ok ? (isSub ? "/portal" : "/admin/users") : "/login");
    } catch (e) { toast.error(e?.response?.data?.detail || e.message); }
    setBusy(false);
  };
  return (
    <div className="mb-4 flex flex-wrap items-center gap-2 rounded-xl border border-amber-300 bg-amber-50 px-4 py-2.5 text-sm text-amber-900 shadow-sm" data-testid="impersonation-banner">
      <UserCog className="h-4 w-4 shrink-0" />
      <span className="font-semibold" data-testid="impersonation-mode" data-mode={isSub ? "sub" : "admin"}>{isSub ? (zh ? "正在以分包商身份代操作：" : "Acting as subcontractor: ") : (zh ? "管理员已切换登录为：" : "Admin logged in as: ")}</span>
      <span data-testid="impersonation-target">{user.nameZh || user.name || user.username}{user.company ? ` · ${user.company}` : ""}{!isSub && user.role ? ` · ${user.role}` : ""}<span className="text-amber-700/70"> (@{user.username})</span></span>
      <span className="text-xs text-amber-700/80">{zh ? `操作者 ${user.impersonatedByName || user.impersonatedBy} · 所有操作将记入审计日志 · 会话 4 小时` : `by ${user.impersonatedByName || user.impersonatedBy} · audited · 4h session`}</span>
      <button onClick={exit} disabled={busy} className="ml-auto inline-flex items-center gap-1.5 rounded-lg bg-amber-600 hover:bg-amber-700 text-white px-3 py-1.5 text-xs font-semibold disabled:opacity-60" data-testid="impersonation-exit">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <LogOut className="h-3.5 w-3.5" />}{zh ? (isSub ? "返回我的账号" : "返回管理员账号") : "Back to my account"}
      </button>
    </div>
  );
};
